export const DEFAULT_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS = 7;
export const MIN_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS = 3;
export const MAX_SUPPORT_TEAM_ACCESS_PERIOD_IN_DAYS = 180;

export interface SupportFormValues {
  goal: string;
  video: string;
  consentToAccess: boolean;
  daysLimit: number;
}

export interface SupportFormSubmission {
  goal: string;
  video: string;
  consentToAccess?: boolean;
  daysLimit?: number;
}

export interface SupportFormModalData {
  accountId: number;
  userId: number;
  userEmail: string;
  supportTeamAccessEnabled: boolean;
  accessGrantedUntil?: number;
  hasEditPermission: boolean;
  initialProblem?: string;
  trackingProperties: {
    'Account Id': number;
    'Requester Name': string;
    'Requester Email': string;
    'Requester User Id': number;
  };
}
